import React from "react";
import { resolveWidgetComponent } from "./widgetRegistry";

function WidgetRenderer({ widget }) {
	const Component = resolveWidgetComponent(widget);

	if (!Component) {
		return (
			<div className="page-widget-error">
				Не удалось отрендерить виджет (widgetType: {widget.widgetType},
				unit не найден или неизвестный тип).
			</div>
		);
	}

	return (
		<Component
			unitId={widget.unit?.id}
			unit={widget.unit}
			config={widget.config}
		/>
	);
}

export default WidgetRenderer;
